import React from 'react';

export default function UnderReview() {
  return (
    <div className="min-h-screen">
      <h1 className="text-4xl font-bold">Under Review</h1>
      <p>Your account is under review</p>
    </div>
  );
}

